planb = {
	resolution: '',
	isMobileApp: false,

	init: function () {
		var
			self = this;

		self.checkMobile();

		jQuery('.js-closeable .js-close').on('click', function () {
			var
				parent = jQuery(this).closest('.js-closeable');

			$.cookie('wndclosed-' + parent.attr('id'), true);

			parent.remove();
			console.log('wndclosed-' + parent.attr('id'));
		});

		//Инициализация форм
		if (_forms.length) {
			for (var i = 0; i < _forms.length; i++)
				new Form($(_forms[i]));
		}

		//Обработка изменения размеров экрана
		jQuery(window).resize(function () {
			self.checkMobile();
		});

		//Проверить, запущен ли сайт из мобильного приложения
		self.checkMobileApp();
	},

	//-------------------------------------------------
	//Проверить, какому устройству соответствует разрешение экрана
	checkMobile: function () {
		var
			width = jQuery(window).width(),
			result = '';

		if (width < 768) result = 'mobile';
		else if (width < 1290) result = 'tablet';
		else result = 'desktop';

		if (this.resolution != result) {
			this.resolution = result;
			jQuery(window).trigger('resolution');
		}
	},

	//-------------------------------------------------
	//Проверить, запущен ли сайт из мобельного приложения
	checkMobileApp: function () {
		var
			userAgent = navigator.userAgent || navigator.vendor || window.operaб
		result = false;

		//Проверка на Android WebView
		if (/Android/i.test(userAgent))
			if (/wv/.test(userAgent)) result = true;

			// Проверка для iOS WebView
			else if (/iPhone|iPad|iPod/i.test(userAgent))
				if (navigator.standalone) result = true;
		result = true;
		this.isMobileApp = result;
	},

	//-------------------------------------------------
	//Инициализировать скрипт mask
	maskInit: function () {
		//Номер телефона
		$('.js-phone-iti:not(.ok)').each(function () {
			var iti = window.intlTelInput(
				this,
				{
					autoPlaceholder: 'aggressive',
					showSelectedDialCode: true,
					// onlyCountries: ['ru', 'kz', 'by', 'kg', 'ae', 'ua', 'tj', 'md', 'am'],
					initialCountry: 'ru',
					// countrySearch: false,
					dropdownContainer: document.body,
					fixDropdownWidth: true,
					nationalMode: false,
					utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/19.2.16/js/utils.js',
					customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
						return selectedCountryPlaceholder.replace(/[0-9]/g, '_');
					},
				}
			);

			$(this).on('input', function (event) {
				var
					$target = $(event.target),
					$hidden = $(`#${$target.data('hidden')}`);

				$hidden.val(iti.getNumber());

				if (iti.isValidNumber()) $hidden.trigger('maskCompleted');
				else $hidden.trigger('maskUncompleted');
			});

			$(this).addClass('ok');
		});

		//Email
		$('.js-email:not(.ok)').each(function () {
			$(this).on('keyup', function () {
				var
					$input = $(this),
					text = $input.val();

				if (
					text.length > 10 &&
					text.includes('@') &&
					text.includes('.')
				)
					$input.trigger('maskCompleted');

				else $input.trigger('maskUncompleted');
			});

			$(this).addClass('ok');
		});
	}
}

//-------------------------------------------------
//Вывести лог в консоль
function dd(val) {
	console.log(val);
}

//-------------------------------------------------
//Проверить переменную на существование
function isset(val) {
	return typeof val !== 'undefined';
}

//-------------------------------------------------
//Получить список url параметров
function urlParams() {
	return (new URL(document.location)).searchParams;
}

//-------------------------------------------------
//Удалить параметр из url
function removeUrlParam(url, parameter) {
	url = url || window.location.href;

	var parts = url.split('?');
	var paramValue = null;

	if (parts.length >= 2) {
		var prefix = encodeURIComponent(parameter) + '=';
		var pars = parts[1].split(/[&;]/g);

		for (var i = pars.length; i-- > 0;) {
			if (pars[i].lastIndexOf(prefix, 0) !== -1) {
				paramValue = decodeURIComponent(pars[i].substring(prefix.length)); // Извлечение значения параметра
				pars.splice(i, 1); // Удаление параметра из массива
			}
		}

		return {
			url: parts[0] + (pars.length > 0 ? '?' + pars.join('&') : ''),
			value: paramValue
		};
	}

	return {
		url: url,
		value: paramValue
	};
}

jQuery(document).ready(function () {
	planb.init();

	//planb.maskInit();

	/*jQuery('.dbi').on('dbi_select', function() {
		alert(jQuery(this).val() + ' (' + jQuery(this).attr('data-value') + ')');
	})*/
});
